import { FIFTEEN_MINUTES, QUERY_KEYS } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { EnterprisesService } from 'services/enterprises';
import { useEnterpriseId } from 'stores/user';
import { type Employee } from 'types/employees';

export const useFetchPatients = (search: string): UseQueryResult<Employee[]> => {
  const enterpriseId = useEnterpriseId();
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_INSURED_USERS, enterpriseId, search],
    queryFn: async () => EnterprisesService.getEmployeesByEnterprise({ enterpriseId, search }),
    select: response => response.data,
    enabled: !!enterpriseId,
    staleTime: FIFTEEN_MINUTES,
  });
};
